export default {
  labels: {
    agent: 'סוכן',
    report: 'דוח',
    user: 'משתמש',
  },
};
